import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE12Items = getItem('FE12', 'FE12', <FolderOutlined />, [
  getItem('Chapter 0 Unit Editor', 'FE12/Chapter0UnitEditor'),
  getItem('Chapter 1 Unit Editor', 'FE12/Chapter1UnitEditor'),
  getItem('Chapter 10 Unit Editor', 'FE12/Chapter10UnitEditor'),
  getItem('Chapter 10x Unit Editor', 'FE12/Chapter10xUnitEditor'),
  getItem('Chapter 11 Unit Editor', 'FE12/Chapter11UnitEditor'),
  getItem('Chapter 12 Unit Editor', 'FE12/Chapter12UnitEditor'),
  getItem('Chapter 13 Unit Editor', 'FE12/Chapter13UnitEditor'),
  getItem('Chapter 13x Unit Editor', 'FE12/Chapter13xUnitEditor'),
  getItem('Chapter 14 Unit Editor', 'FE12/Chapter14UnitEditor'),
  getItem('Chapter 15 Unit Editor', 'FE12/Chapter15UnitEditor'),
  getItem('Chapter 16 Unit Editor', 'FE12/Chapter16UnitEditor'),
  getItem('Chapter 16x Unit Editor', 'FE12/Chapter16xUnitEditor'),
  getItem('Chapter 17 Unit Editor', 'FE12/Chapter17UnitEditor'),
  getItem('Chapter 18 Unit Editor', 'FE12/Chapter18UnitEditor'),
  getItem('Chapter 19 Unit Editor', 'FE12/Chapter19UnitEditor'),
  getItem('Chapter 2 Unit Editor', 'FE12/Chapter2UnitEditor'),
  getItem('Chapter 20 Unit Editor', 'FE12/Chapter20UnitEditor'),
  getItem('Chapter 20x Unit Editor', 'FE12/Chapter20xUnitEditor'),
  getItem('Chapter 21 Unit Editor', 'FE12/Chapter21UnitEditor'),
  getItem('Chapter 22 Unit Editor', 'FE12/Chapter22UnitEditor'),
  getItem('Chapter 23 Unit Editor', 'FE12/Chapter23UnitEditor'),
  getItem('Chapter 24 Unit Editor', 'FE12/Chapter24UnitEditor'),
  getItem('Chapter 3 Unit Editor', 'FE12/Chapter3UnitEditor'),
  getItem('Chapter 3x Unit Editor', 'FE12/Chapter3xUnitEditor'),
  getItem('Chapter 4 Unit Editor', 'FE12/Chapter4UnitEditor'),
  getItem('Chapter 5 Unit Editor', 'FE12/Chapter5UnitEditor'),
  getItem('Chapter 6 Unit Editor', 'FE12/Chapter6UnitEditor'),
  getItem('Chapter 6x Unit Editor', 'FE12/Chapter6xUnitEditor'),
  getItem('Chapter 7 Unit Editor', 'FE12/Chapter7UnitEditor'),
  getItem('Chapter 8 Unit Editor', 'FE12/Chapter8UnitEditor'),
  getItem('Chapter 9 Unit Editor', 'FE12/Chapter9UnitEditor'),
  getItem('Chapter BSFE1 Unit Editor', 'FE12/ChapterBSFE1UnitEditor'),
  getItem('Chapter BSFE2 Unit Editor', 'FE12/ChapterBSFE2UnitEditor'),
  getItem('Chapter BSFE3 Unit Editor', 'FE12/ChapterBSFE3UnitEditor'),
  getItem('Chapter BSFE4 Unit Editor', 'FE12/ChapterBSFE4UnitEditor'),
  getItem('Chapter DL1 Unit Editor', 'FE12/ChapterDL1UnitEditor'),
  getItem('Chapter DL2 Unit Editor', 'FE12/ChapterDL2UnitEditor'),
  getItem('Chapter DL3 Unit Editor', 'FE12/ChapterDL3UnitEditor'),
  getItem('FE12 Character Editor', 'FE12/CharacterEditor'),
  getItem('FE12 Class Editor (U)', 'FE12/ClassEditorU'),
  getItem('FE12 Class Slot Editor', 'FE12/ClassSlotEditor'),
  getItem('FE12 Item Editor (U)', 'FE12/ItemEditorU'),
  getItem('FE12 Terrain Cost Data Editor', 'FE12/TerrainCostDataEditor'),
  getItem('FE12 Terrain Data Editor', 'FE12/TerrainDataEditor'),
]);

export default FE12Items;
